var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHatChef(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0156 2.57812C10.5568 2.58087 10.1119 2.73193 9.74671 3.01208C9.23364 2.32544 8.40308 1.875 7.5 1.875C6.55737 1.875 5.76636 2.32544 5.25439 3.01208C4.61719 2.52319 3.76025 2.4408 3.04394 2.79785C2.3228 3.15205 1.87225 3.8855 1.875 4.6875C1.875 5.60486 3.28125 8.90625 3.28125 8.90625H4.91711L4.34033 5.44995C4.30957 5.23901 4.43701 5.07642 4.62817 5.04346C4.8163 5.00843 5.00127 5.13873 5.03357 5.33108L5.63013 8.90625H7.14844V5.39062C7.14844 5.1963 7.30567 5.03906 7.5 5.03906C7.69433 5.03906 7.85156 5.1963 7.85156 5.39062V8.90625H9.37031L9.96621 5.3313C9.99849 5.13904 10.1856 5.00874 10.3716 5.04368C10.5632 5.07527 10.6913 5.25773 10.6592 5.44929L10.084 8.90625H11.7188C11.7188 8.90625 13.125 5.60376 13.125 4.6875C13.125 3.52295 12.1802 2.57812 11.0156 2.57812ZM3.28125 12.4219C3.28125 12.8086 3.59765 13.125 3.98437 13.125H11.0156C11.4023 13.125 11.7188 12.8086 11.7188 12.4219V9.60938H3.28125V12.4219Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHatChef);
export default __webpack_public_path__ + "static/media/hat_chef.3f6f62cecde6e94dff83104c88b0ceeb.svg";
export { ForwardRef as ReactComponent };